import {
  HISTORY_TABLE_DATA,
  LOADER_STATUS,
  SELECT_UNIQUE,
  SELECTED,
  TOTAL_PAGES_HISTORY,
  TOTAL_PAGES_VIEW,
  VIEW_TABLE_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  viewTableData: [],
  historyTableData: [],
  totalPagesView: 1,
  totalPagesHistory: 1,
  selected:[],
  selectUnique:[]
};

/* eslint-disable default-case, no-param-reassign */
const gstr2a2bNewFetchReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case VIEW_TABLE_DATA:
      return {
        ...state,
        viewTableData: action.viewTableData,
      };
    case HISTORY_TABLE_DATA:
      return {
        ...state,
        historyTableData: action.historyTableData,
      };
    case TOTAL_PAGES_VIEW:
      return {
        ...state,
        totalPagesView: action.totalPagesView,
      };
    case TOTAL_PAGES_HISTORY:
      return {
        ...state,
        totalPagesHistory: action.totalPagesHistory,
      };
      case SELECTED:
      return {
        ...state,
        selected: action.selected,
      };
      case SELECT_UNIQUE:
      return {
        ...state,
        selectUnique: action.selectUnique,
      };
    default:
      return state;
  }
};

export default gstr2a2bNewFetchReducer;
